import React from 'react'
import { motion } from "framer-motion";
const CertificationsCard = ({ tableData, i }) => {
    return (
        <motion.div className='certifications-card'
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ ease: "easeInOut", delay: .1, duration: 0.25 }}
        >
            <ol>
                {tableData.map((data, index) => (
                    <motion.li
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ ease: "easeInOut", delay: parseFloat(i/10+.2), duration: 0.25 }}
                        key={index}> {data !== "" && <span>
                            {i === 0 ? `0${index + 1} ` :
                                i === 1 ? `0${index + 5} ` :
                                    i === 2 ? index < 1 ? `0${index + 9} ` : index + 9 :
                                        i === 3 ? index + 13 :
                                            i === 4 ? index + 17 : index + 21

                            }
                        </span>} {data}</motion.li>
                ))}
            </ol>
        </motion.div>
    )
}

export default CertificationsCard